export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M16.473 3.22a.75.75 0 0 1 1.06 0l3.247 3.247a.75.75 0 0 1 0 1.06L10.038 18.27a.753.753 0 0 1-.223.154L3.93 21.061a.75.75 0 0 1-.991-.99l2.637-5.885a.753.753 0 0 1 .155-.224L16.473 3.22ZM6.889 14.925l-1.776 3.962 3.962-1.776 7.282-7.281-2.187-2.187-7.281 7.282Zm7.988-7.989 2.187 2.186 2.126-2.125-2.187-2.186-2.126 2.125Z"/>
</svg>
`;
